<template>
  <b-row>
    <b-col cols="12">
      <category-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import CategoryContent from './CategoryContent.vue'

export default {
  components: {
    BRow,
    BCol,

    CategoryContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>